"use strict";

import React, {Component} from "react";
import { PropTypes} from "Subschema";
import CustomMaskedInput from "./CustomMaskedInput";

function createCVCFormatter(value) {
    value = value == null ? 4 : value;
    let formatter = '';
    for (let i = 0; i < value; i++) {
        formatter += '1';
    }
    return formatter;
}

export default class CVC extends Component {

    static propTypes = {
        "cvcLength": PropTypes.value,
        "cardType": PropTypes.value,
        "onChange": PropTypes.targetEvent,
        "style": PropTypes.style,
        "error": PropTypes.error
    };

    static injectedProps = {
        "cvcLength": "..cvcLength",
        "cardType": "..cardType",
        "style": "Card",
        "placeholderChar":" "
    };

    static contextTypes = {
        maskedInoutUnsupported: React.PropTypes.bool
    }

    constructor(props, ...rest) {
        super(props, ...rest);
        this.formatter = createCVCFormatter(props.cvcLength);
    }

    componentWillReceiveProps(props) {
        if (props.cvcLength !== this.props.cvcLength) {
            this.formatter = createCVCFormatter(props.cvcLength);
        }
    };

    render() {
        const {cvcLength, cardType, error, formatter, hasErrorClass, defaultCvvClass, style, creditCardClass, className, ...props} = this.props;

        const amexClass = (cardType === 'amex') ? props.AMEXCvvClass : '';
        return <span className={className}>
            <CustomMaskedInput {...props} mask={this.formatter} placeholderChar={' '}/>
            <i className={`${error ? hasErrorClass : ''} ${defaultCvvClass} ${creditCardClass} ${amexClass}`}/>
        </span>

    }
}



/** WEBPACK FOOTER **
 ** ./src/types/card/CVC.jsx
 **/